import { render } from "./CopyCsvTd.vue?vue&type=template&id=5a8ee150"
import script from "./CopyCsvTd.vue?vue&type=script&lang=js"
export * from "./CopyCsvTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__